import plTranslation from "./pl/translation";

const resources = {
  pl: {
    translation: plTranslation,
  },
};

export default resources;